import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultViewRedirectFlagTitle: {
		id: 'business-horizontal-nav.project-navigation.default-view-redirect-flag-title',
		defaultMessage: "We've taken you to the default view",
		description:
			'Error message title informing the user that they were redirected to the default view.',
	},
	defaultViewRedirectFlagDescription: {
		id: 'business-horizontal-nav.project-navigation.default-view-redirect-flag-description',
		defaultMessage: "The view you're trying to access has been removed.",
		description:
			'Error message description informing the user that the view they are trying to access has been removed.',
	},
	customTemplateProjectBannerMessage: {
		id: 'jira-horizontal-nav.custom-template-project-banner-message',
		defaultMessage:
			'This project is saved as a custom template. Project settings changes will apply to the template.',
		description:
			'Description shown to use to inform that the current project is being used as a custom template',
	},
	projectNavigation: {
		id: 'jira-horizontal-nav.project-navigation',
		defaultMessage: 'Project navigation',
		description: 'Label for the project container navigation',
	},
});
